import { css } from '@emotion/react'

import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        dialogRoot: custom.boxShadowRadius,
        dialogContentRoot: css`
            ${common.flexJustityAlignCenter};
            padding: 40px 30px 0px 30px;
        `,
        dialogActionsRoot: css`
            ${common.dialogActionsRoot};
            padding-bottom: 40px;
        `,
        button: css`
            ${custom.button};
            margin: 0 40px;
            padding: 0;
        `,
        icon: css`
            width: 70px;
            height: 80px;
            padding-right: 25px;
        `,
    }
}

export default styles
